(() => {
  const init = (root) => {
    if (!root || root.dataset.tailLumaReady === 'true') return;
    root.dataset.tailLumaReady = 'true';
    const reveals = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
      }, { threshold: .12 });
      reveals.forEach((item) => revealObserver.observe(item));
    } else reveals.forEach((item) => item.classList.add('is-visible'));
    const links = [...root.querySelectorAll('.tail-luma__nav a')];
    const targets = links.map((link) => root.querySelector(link.getAttribute('href'))).filter(Boolean);
    if ('IntersectionObserver' in window && targets.length) {
      const navObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) { links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${entry.target.id}`)); } });
      }, { rootMargin: '-20% 0px -68% 0px' });
      targets.forEach((target) => navObserver.observe(target));
    }
  };
  document.querySelectorAll('.tail-luma').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.tail-luma')));
})();
